import { apiProxyRequest as request } from "Api/apiProxyRequest";

export const deleteProjectUserAccess = (projectId: string, userId: string) =>
  request(`/projects/${projectId}/user-access/${userId}`, "DELETE");
